import { render, staticRenderFns } from "./todoDetailsEnrollInfor.vue?vue&type=template&id=4ec11c79&"
import script from "./todoDetailsEnrollInfor.vue?vue&type=script&lang=js&"
export * from "./todoDetailsEnrollInfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports